import React, { useState, useEffect, useRef, Fragment } from 'react';
import Header from '../commons/Header';
import Footer from '../commons/Footer';
import { useHistory, NavLink, Link } from "react-router-dom";
import { PROJECTNAMEALIAS, NFTAPIBASENAME, COLLECTIONIMAGEBASEURL, NFTIMAGEBASEURL, ERC721ABI } from '../helpers/Setup'
import { showToast, callAPI, showHttpError, checkIfUserIsLoggedIn, getAllSessionData, handleCartManipulation, showPopupWithImage, addToFavorite, removeFromFavorite, isNftAddedToCart, getCollectionDetailsFromLibrary, getBlockChainContract, fetchCommissionRate, isUserSessionActive, handleLogout } from '../helpers/Library';
import Loader from '../commons/Loader';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import moment from 'moment';
import { ethers } from "ethers";
import web3 from "web3";
import { Seaport } from "@opensea/seaport-js";
import { Chain, OpenSeaSDK } from "opensea-js";
import BigNumber from "bignumber.js";
import axios from 'axios';
import DateTimePicker from 'react-datetime-picker';

const AssetDetails = (props) => {
    const history = useHistory();
    const [nftId, setNftId] = useState(null)
    const [collectionId, setCollectionId] = useState(null)
    const [nft, setNft] = useState({})
    const [nftOffers, setNftOffers] = useState([])
    const [floorBids, setFloorBids] = useState([])
    const [nftSaleListing, setNftSaleListing] = useState([])
    const [showLoader, setShowLoader] = useState(false);
    const [initiateMakeOffer, setInitiateMakeOffer] = useState(false);
    const [initiateAddForSale, setInitiateAddForSale] = useState(false);
    const [initiateTransfer, setInitiateTransfer] = useState(false);
    const [disableAddToCartBtn, setDisableAddToCartBtn] = useState(false);
    const [disableMakeAnOfferBtn, setDisableMakeAnOfferBtn] = useState(false);
    const [isValidSalePrice, setValidSalePrice] = useState(false);
    const [isValidOfferPrice, setValidOfferPrice] = useState(false);
    const [hidePriceSection, setPriceSection] = useState(false);
    const [isValidTransferAddress, setIsValidTransferAddress] = useState(false);
    const [notableNftLists, setNotableNftLists] = useState([]);
    const [durations, setDurations] = useState([]);
    const [userBalance, setUserBalance] = useState(0);
    const [totalViewed, setTotalViewed] = useState(0);
    const [nftPriceDetails, setNftPriceDetails] = useState({});

    const [showBuyConfirmationModal, setShowBuyConfirmationModal] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [showInsufficientBalancePopup, setInsufficientBalancePopup] = useState(false);
    const [showTransferForMetaMaskPopup, setTransferForMetaMaskPopup] = useState(false);
    const [showUpdateCommissionRatePopup, setUpdateCommissionRatePopup] = useState(false);
    const [showListForSaleForMetaMaskPopup, setListForSaleForMetaMaskPopup] = useState(false);
    const [isTransferForMetamaskSuccess, setTransferForMetaMaskSuccess] = useState(false);
    const [showListForSaleSuccessMetaMask, setShowListForSaleSuccessMetaMask] = useState(false);
    const [metaMaskTransferId, setMetaMaskTransferId] = useState('')
    const [transactionFees, setTransactionFees] = useState('')
    const [collectionName, setCollectionName] = useState('');
    const [offerStartInterval, setOfferStartInterval] = useState(null);
    const [activities, setActivities] = useState([]);
    const [activityPageNo, setActivityPageNo] = useState(1);
    const [activityPageSize, setActivityPageSize] = useState(10);
    const [activityTotalCount, setActivityTotalCount] = useState(0);
    const [activityPageList, setActivityPageList] = useState([]);
    const [activityFilterType, setActivityFilterType] = useState('ALL');
    const [userOfferCount, setUserOfferCount] = useState(0);
    const [commission, setCommission] = useState(0);
    const [commissionRate, setCommissionRate] = useState(0);
    const [expiredValue, setExpiredValue] = useState(new Date());
    const [offerExpires, setOfferExpires] = useState(new Date());

    /* Method defination for setting expire date */
    let handleExpiredValue = (date) => {
        console.log(date)
        setExpiredValue(date)
    }
    let handleOfferExpiredOn = (date) => {
        console.log(date)
        setOfferExpires(date)
    }

    /* Method defination for rendering pagination */
    let renderPagination = (totalCount) => {
        let limit = Math.ceil(totalCount / activityPageSize)
        console.log(totalCount, activityPageSize, limit)
        let arr = [];
        for (let i = 1; i <= limit; i++) {
            arr.push(i)
        }
        setActivityPageList(arr, console.log('activityPageList', activityPageList))
    }

    /* Method defiantion for draging slider */
    const handleDragStart = (e) => e.preventDefault();

    /* Setting up notable nft list for sliders  */

    const responsiveForSliders = {
        0: { items: 1 },
        568: { items: 3 },
        1024: { items: 5 },
    }

    /* Method defination for rendering commistion rate  */
    const calculateCommission = async (price, commissionRate) => {
        // Ensure salePrice is a number and commissionRate is properly formatted
        console.log('Price..' + price);
        const salePriceInETH = parseFloat(price); // Assuming the input is in ETH
        const commission = (salePriceInETH * commissionRate) / 100; // Calculate commission
        console.log('commission...' + commission);
        setCommission(commission.toFixed(12)); // Return commission with 12 decimal places for clarity 
        localStorage.setItem(localStorage.getItem('nftBrokerExchangeName') + '_nft_' + 'commission_rate', commission.toFixed(12));

    };

    /* Method defination to fetch user balance */
    let getUserBalance = () => {
        // if (getAllSessionData().loginPlatform == 'paybito') {
        //     let payload = { "uuid": getAllSessionData().uuid }
        //     setShowLoader(true)
        //     callAPI('post', NFTAPIBASENAME + '/transaction/getUserBalance', payload, true).then((res) => {
        //         let response = res.data;
        //         setShowLoader(false);
        //         console.log(response);
        //         if (response.error.error_data != 0) {
        //             showToast('error', response.error.error_msg)
        //         } else {
        //             let userBalanceList = response.userBalanceList
        //             if (userBalanceList != null) {
        //                 for (let i = 0; i < userBalanceList.length; i++) {
        //                     if (userBalanceList[i].currencyId == 3) {
        //                         setUserBalance(userBalanceList[i].closingBalance)
        //                     }
        //                 }
        //             }

        //         }

        //     }, (error) => {
        //         setShowLoader(false);
        //         showHttpError(error)
        //     })

        // } else if (getAllSessionData().loginPlatform == 'metamask') {
        let account = getAllSessionData().account;
        window.ethereum
            .request({ method: "eth_getBalance", params: [account, "latest"] })
            .then((balance) => {
                console.log('balance', ethers.utils.formatEther(balance))
                setUserBalance(ethers.utils.formatEther(balance))
            })
            .catch((error) => {
                console.log("Could not detect the Balance");
            });

        //}

    }

    
   

    /* Method defination for open make offer popup */
    let openMakeOfferPopup = () => {
       
        getUserBalance();
        setInitiateMakeOffer(true);
    }
    /* Method defination for open make offer popup */
    let openAddForSalePopup = () => {
        //if (getAllSessionData().loginPlatform == 'paybito') {
        getUserBalance();
        setInitiateAddForSale(true)
        // } else if (getAllSessionData().loginPlatform == 'metamask') {

        // }

    }

    /* Method defination for getting NFT details */
    let getNftDetails = async (collectionId, nftId) => {
        setShowLoader(true)
        let contract = await getBlockChainContract();

        //if (!contract) return;
        try {
            const query = `
            {
  nft(id: "${nftId}") {
    id
    tokenURI
    price
    owner
    creator
    contractAddress
    collection {
      id
      name
      description
      backgroundImage
      creator
      volume
     
    }
  }
}




          `;

            // Fetch collections data from the subgraph
            const response = await axios.post('https://api.studio.thegraph.com/query/108358/paybito_nft_marketplace/v0.0.1', { query });
            const now = Math.floor(Date.now() / 1000);
            console.log(response)
            const nft = response.data.data.nft;

            let offers = [];
            setCollectionId(collectionId)
            setCollectionName(nft.collection.name)
            setNftId(nft.id)
            let floorBidObj = {}
            if(contract){
                const floorBidData = await contract.methods.getFloorBid(collectionId).call();
                console.log('floorBidData', floorBidData);
                const isFloorBidExpired = floorBidData.expirationTime > 0 && now > floorBidData.expirationTime;
                let expirationTime = await contract.methods.getListingExpiration(nft.id).call();
                //console.log('expirationTime1',expirationTime,expirationTime.toString())
                expirationTime = expirationTime.toString();
                //console.log('expirationTime2',expirationTime)
                expirationTime = parseInt(expirationTime)
                //console.log('expirationTime3',expirationTime,Math.floor(new Date(expirationTime).getTime() / 1000))
    
                const isListingExpired = expirationTime > 0 && now > expirationTime;
                nft.isExpired = isListingExpired
                nft.expirationTime = expirationTime
                floorBidObj = {
                bidder: floorBidData.bidder,
                bidAmount: web3.utils.fromWei(floorBidData.bidAmount.toString(), 'ether'),
                expirationTime: floorBidData.expirationTime,
                isExpired: isFloorBidExpired,
            }
                
            }    

            nft.collection.floorBid = floorBidObj;
            let arr = [];
            arr.push(nft.collection.floorBid)
            setFloorBids(arr);
            console.log('NFT => ', nft)
            try {
                const metadataUrl = nft.tokenURI.replace('ipfs://', 'https://ipfs.io/ipfs/');
                const { data: metadata } = await axios.get(metadataUrl);
                nft.metadata = metadata

                // Fetch price, owner, and offer
                if(contract){
                    const offer = await contract.methods.getOffer(nftId).call();
                    const expirationTime = await contract.methods.getListingExpiration(nftId).call();
                    const isExpired = expirationTime > 0 && now > expirationTime;
                    const isOfferExpired = offer[2] > 0 && now > offer[2]; // Check expiration
                    //nft.expirationTime = expirationTime > 0 ? expirationTime : null,
                    offers.push({
                        offerer: offer[0],
                        offerAmount: offer[1],
                        offerExpiration: offer[2],
                        isExpired: isOfferExpired,
                    })
                    console.log(offers)
                }else{
                    const offers = []
                }
                    setNft(nft)
                    setNftOffers(offers)
                

                if (nft.price > 0 && nft.price != null) {
                    let price = web3.utils.fromWei(nft.price.toString(), 'ether');
                    let commissionRate = await fetchCommissionRate();
                    calculateCommission(price, commissionRate)
                }
            } catch (error) {
                showToast('error', 'Error fetching metadata for NFT:' + error);
                return null; // Handle errors gracefully
            }
            setShowLoader(false)




        } catch (error) {
            showToast('error', 'Error fetching all collections:' + error);
            console.log(error)
        }



    }

   
    /* Method defination for getting all offer by NFT */
    let getAllSaleListingOfNft = (param) => {
        let payload = { "entityId": param, "pageNo": "1", "pageSize": "10" }
        setShowLoader(true)
        callAPI('post', NFTAPIBASENAME + '/nft/market/public/getAllSalesByNft', payload, false).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                if (response.nftSales != null) {
                    setNftSaleListing(response.nftSales);
                    let minSalePrice = Math.min.apply(Math, response.nftSales.map(a => a.salePrice));
                    for (let i = 0; i < response.nftSales.length; i++) {
                        let iter = response.nftSales[i];
                        if (minSalePrice == iter.salePrice) {
                            let obj = iter
                            setNftPriceDetails(obj);
                            break;
                        }
                    }
                } else {
                    setDisableAddToCartBtn(true)
                    // setDisableMakeAnOfferBtn(true)
                    setPriceSection(true)
                }

            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })
    }

    /* Method defination for getting view count  */
    let getViewCount = (id) => {
        let payload = { "entityId": id, "entityType": "N" }
        setShowLoader(true);
        callAPI('post', NFTAPIBASENAME + '/nft/market/public/getViewerCount', payload, false).then((res) => {
            let response = res.data;
            setShowLoader(false)
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                setTotalViewed(response.totalCount)
            }
        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })
    }
    /* Method defination for getting other NFT from same collection */
    let getOtherNftFromSameCollection = async (collectionId) => {


        setShowLoader(true);
        let contract = await getBlockChainContract();

        //if (!contract) return;
        try {
            const query = `
            {
  collection(id: ${collectionId}) {
    id
    name
    description
    backgroundImage
    creator
    volume
    nfts {
      id
      tokenURI
      price
      owner
      creator
      invalidated
            contractAddress
    }
  }
}

          `;

            const response = await axios.post('https://api.studio.thegraph.com/query/108358/paybito_nft_marketplace/v0.0.1', { query });
            const now = Math.floor(Date.now() / 1000);
            const collection = response.data.data.collection;

            //console.log('collection => ', collection)

            const detailedNFTs = await Promise.all(
                collection.nfts.map(async (nft) => {
                    const metadataUrl = nft.tokenURI.replace('ipfs://', 'https://ipfs.io/ipfs/');
                    const { data: metadata } = await axios.get(metadataUrl);

                    // Fetch price, owner, and offer
                    const price = nft.price; // Already part of the struct
                    const owner = nft.owner; // Already part of the struct
                    const contractAddress = nft.contractAddress.toLowerCase();
                    //const offer = await contract.methods.getOffer(nft.id).call();

                    return {
                        ...nft,
                        contractAddress,
                        metadata,
                        price, // Price is already part of the NFTDetails struct
                    };
                })
            );

            //console.log(detailedNFTs)
            let notableNftLists = []
            for (let i = 0; i < detailedNFTs.length; i++) {
                let nft = detailedNFTs[i]
                //if (props.match.params.nftId != nft.id) {
                let html = <Fragment>
                    <div className="special-grid best-seller" onDragStart={handleDragStart} role="presentation">

                        <div className="products-single fix">
                            <div className="box-img-hover">
                                {nft.price > 0 && nft.price != null && <div className="type-lb">
                                    <p className="sale">Sale</p>
                                </div>}
                                {nft.metadata != undefined && <img src={nft.metadata.image.replace('ipfs://', 'https://ipfs.io/ipfs/')} className="img-fluid" alt="Image" />}
                                <div className="mask-icon">
                                    <ul>
                                        <li><Link to={`/asset/${collectionId}/${nft.id}`} onClick={(e) => {
                                            setTimeout(() => {
                                                window.location.reload()
                                            }, 600);
                                        }}><i className="fas fa-eye"></i></Link></li>
                                        {/* <li>{nft.isFavourite == 1 ? <Fragment><a href={props.match.params.id} data-toggle="tooltip" data-placement="right" title="Remove from Favorites" onClick={(e) => {
                                                e.preventDefault(); removeFromFavorite(nft.nftId, () => { window.location.reload() })
                                            }}><i className="fa fa-solid fa-heart"></i></a></Fragment> : <Fragment><a href={props.match.params.id} data-toggle="tooltip" data-placement="right" title="Add to Favorites" onClick={(e) => {
                                                e.preventDefault(); addToFavorite(nft.nftId, () => { window.location.reload() })
                                            }}><i className="far fa-heart"></i></a></Fragment>}</li> */}
                                    </ul>
                                    {/* <a className="cart" href="javascript:void(0);" onClick={() => { handleCartManipulation(nft, 'add') }}>Add to Cart</a> */}
                                </div>
                            </div>
                            <div className="why-text">
                                <h4>{nft.metadata.name}</h4>
                                {<h5> {nft.price > 0 && nft.price != null ? web3.utils.fromWei(nft.price.toString(), 'ether') + ' ETH' : 'Not For Sale'}</h5>}
                            </div>
                        </div>
                    </div>
                </Fragment>
                notableNftLists.push(html);
                //}
            }
            setNotableNftLists(notableNftLists)
            console.log(notableNftLists)
            setShowLoader(false)
        } catch (error) {
            showToast('error', 'Error fetching all collections:' + error);
            console.log(error)
        }



    }

    /* method defination for buy nft */
    const buyNft = async () => {
        let isSessionActive = await isUserSessionActive();
        console.log(isSessionActive.isActive);
        if (isSessionActive.isActive) {
            let contract = await getBlockChainContract();
            if (!contract) {
                showToast('error', 'Contract is not initialized');
                return;
            }
            if (! await checkTokenOwnership(nft.contractAddress, nft.id)) {
                showToast('error', "You are currently not holding the NFT");
                return;
            }
            try {
                setShowLoader(true)
                const estimatedGas = await contract.methods
                    .buyNFT(nft.id, nft.contractAddress)
                    .estimateGas({ from: getAllSessionData().account, value: nft.price });
                await new Promise((resolve, reject) => {
                    console.log('in promise')
                    contract.methods
                        .buyNFT(nft.id, nft.contractAddress)
                        .send({ from: getAllSessionData().account, value: nft.price, gas: estimatedGas, })
                        .on('transactionHash', (hash) => {
                            setShowLoader(false)
                            console.log('Transaction Hash:', hash);
                        })
                        .on('receipt', (receipt) => {
                            console.log(receipt)
                            let payload = { "nftTransaction": { "collectionAddress": props.match.params.collectionId, "tokenId": props.match.params.nftId, "toUserUuid": getAllSessionData().uuid, "toUserAddress": getAllSessionData().account, "amount": web3.utils.fromWei(nft.price.toString(), 'ether'), "commissionRate": localStorage.getItem(localStorage.getItem('nftBrokerExchangeName') + '_nft_' + 'commission_rate') } }

                            resolve()
                            callAPI('post', NFTAPIBASENAME + '/nft/market/updateNftSale', payload, true).then((res) => {
                                let response = res.data;
                                setShowLoader(false)
                                if (response.error.error_data != 0) {
                                    showToast('error', response.error.error_msg)
                                } else {
                                    showPopupWithImage(nft.nftName, 'Transaction complete. Your NFT ownership has been confirmed.', nft.metadata.image.replace('ipfs://', 'https://ipfs.io/ipfs/'))

                                }
                            }, (error) => {
                                setShowLoader(false);
                                showHttpError(error)
                            })
                            getNftDetails(props.match.params.collectionId, props.match.params.nftId)
                            setShowLoader(false)
                        }, (error) => {
                            setShowLoader(false);
                            showHttpError(error)
                        }).on('error', (error) => {
                            console.log(error)
                            setShowLoader(false)
                            // showToast('error', 'Error Creating collection:' + error);
                            if (error.code === 4001) {
                                showToast('error', "Transaction rejected by the user.");
                            } else {
                                showToast('error', 'Error Buying NFT:' + error);
                            }
                            reject(error);
                        }).catch((error) => {
                            setShowLoader(false)
                            if (error.code === 4001) {
                                console.log('User denied transaction signature.');
                                showToast("error", "Transaction rejected by the user.");
                            } else {
                                showToast('error', 'Error in sending transaction:' + error);
                                showToast("error", `Unexpected error: ${error.message}`);
                            }
                            reject(error);
                        });
                });

            } catch (error) {
                showToast('error', 'Error buying NFT:' + error);
                setShowLoader(false)
            }
        } else {
            handleLogout()
            setShowLoader(false)
            showToast('error', 'Your session has expired, please login again');
        }

    }
    /* Method defination for buy option from listing */
    let handleBuyFromListing = (obj) => {
        console.log(obj)
        if (!checkIfUserIsLoggedIn()) {
            showToast('error', 'Please login to continue');
        } else {

            if (nft.isExternal == '1') {
                setShowLoader(true);
                let payload = { "entityId": nft.collectionId }
                callAPI('post', NFTAPIBASENAME + '/nft/market/public/getContractAbiById', payload, false).then(async (res) => {
                    let response = res.data;
                    setShowLoader(false);
                    console.log(response);
                    if (response.error.error_data != 0) {
                        showToast('error', response.error.error_msg)
                    } else {
                        let resp = response;
                        //Calling the metamask plugin
                        const ABI = JSON.parse(resp.contractAbi);
                        const CONTRACT_ADDRESS = resp.address;
                        console.log(ABI, CONTRACT_ADDRESS)
                        const Web3 = new web3(window.ethereum);
                        var myContract = new Web3.eth.Contract(ABI, CONTRACT_ADDRESS, { from: getAllSessionData().account });
                        console.log(myContract);
                        setShowLoader(true)
                        let transferToAddress = getAllSessionData().account;

                        myContract.methods.setApprovalForAll(transferToAddress, true).send({ from: obj.ownerAddress, gas: 300000 }).then(async (rps) => {
                            console.log('On approval success', rps)
                            console.log('Owner Address', obj.ownerAddress)
                            console.log('Buyer Address', getAllSessionData().account)
                            console.log('Token Id', nft.id)
                            //const gasLimit = await myContract.methods.safeTransferFrom(obj.ownerAddress, getAllSessionData().account, nft.id).estimateGas({ from: obj.ownerAddress });
                            // Get current gas price
                            const gasPrice = await Web3.eth.getGasPrice();
                            // Calculate transaction cost
                            //const transactionCost = gasLimit * gasPrice;
                            // Check if sender has enough balance to cover transaction cost
                            const balance = await Web3.eth.getBalance(getAllSessionData().account);
                            let balance1 = await web3.utils.fromWei(balance, "ether")
                            console.log('sender balance :: ', balance1, getAllSessionData().account)
                            if (balance < 0) {
                                showToast('error', "Insufficient funds to cover transaction cost");
                            } else {

                                myContract.methods.transferFrom(obj.ownerAddress, getAllSessionData().account, nft.id).send({ from: obj.ownerAddress, gas: 300000 }).then((res) => {
                                    console.log('On Success NFT BUY', res);
                                    let payload = { "userUuid": getAllSessionData().uuid, "entityId": obj.nftSaleId, "isExternal": 1, transaction: res.transactionHash }

                                    setShowLoader(true)
                                    callAPI('post', NFTAPIBASENAME + '/nft/market/buyFromSale', payload, true).then((res) => {
                                        let response = res.data;
                                        setShowLoader(false);
                                        console.log(response);
                                        if (response.error.error_data != 0) {
                                            // showToast('error', response.error.error_msg)
                                            setInsufficientBalancePopup(true)
                                            setShowBuyConfirmationModal(false)

                                        } else {
                                            //showToast('success', 'NFT bought successfully')
                                            setShowBuyConfirmationModal(false)
                                            showPopupWithImage(nft.nftName, 'NFT bought successfully', NFTIMAGEBASEURL + '/' + nft.nftFileName)
                                            setTimeout(() => {
                                                window.location.reload()
                                            }, 600);
                                            
                                        }

                                    }, (error) => {
                                        setShowLoader(false);
                                        showHttpError(error)
                                    })

                                }).catch((error) => {
                                    console.log(error);
                                    showToast('error', 'Buy NFT has been rejected ' + error)
                                    setShowLoader(false)
                                });
                            }








                        }).catch((error) => {
                            showToast('error', 'Your approval process has been rejected ' + error)
                            setShowLoader(false)
                        })


                    }
                }, (error) => {
                    setShowLoader(false);
                    showHttpError(error)
                })

            } else {

                let payload = { "userUuid": getAllSessionData().uuid, "entityId": obj.nftSaleId, "isExternal": 0 }

                setShowLoader(true)
                callAPI('post', NFTAPIBASENAME + '/nft/market/buyFromSale', payload, true).then((res) => {
                    let response = res.data;
                    setShowLoader(false);
                    console.log(response);
                    if (response.error.error_data != 0) {
                        // showToast('error', response.error.error_msg)
                        setInsufficientBalancePopup(true)
                        setShowBuyConfirmationModal(false)

                    } else {
                        //showToast('success', 'NFT bought successfully')
                        setShowBuyConfirmationModal(false)
                        showPopupWithImage(nft.nftName, 'NFT bought successfully', NFTIMAGEBASEURL + '/' + nft.nftFileName)
                        setTimeout(() => {
                            window.location.reload()
                        }, 600);
                        
                    }

                }, (error) => {
                    setShowLoader(false);
                    showHttpError(error)
                })
            }


        }
    }

   

    /* Method defination for validating offer price */
    let validateOfferPrice = (offerPrice) => {
        if (nft.price != null && nft.price != undefined) {
            console.log(offerPrice, web3.utils.fromWei(nft.price.toString(), 'ether'))
            if (parseFloat(offerPrice) <= parseFloat(web3.utils.fromWei(nft.price.toString(), 'ether'))) {
                setValidOfferPrice(false)
            } else {
                setValidOfferPrice(true)
            }

        } else {
            if (parseFloat(offerPrice) >= 0.0001) {
                setValidOfferPrice(true)
            } else {
                setValidOfferPrice(false)
            }
        }
    }

    /* method defination for make an offer */
    let handleMakeAnOffer = async () => {
        let offerPrice = document.getElementById('offerPrice').value;
        //let offerDuration = document.getElementById('offerDuration').value;
        //let offerStartDate = document.getElementById('offerStartDate').value;

        if (offerPrice != '') {
            let isSessionActive = await isUserSessionActive();
            if (isSessionActive.isActive) {
                let contract = await getBlockChainContract();

                if (!contract) return;
                  if (getAllSessionData().isLoggedInMetaMask !== 'true') {
                    showToast('error', 'Please login with MetaMask');
                    return;
                  }
                //const amount = Web3.utils.toWei
                const amount = web3.utils.toWei(offerPrice, 'ether');
                try {
                    setShowLoader(true);
                    const expirationTime = Math.floor(new Date(offerExpires).getTime() / 1000);
                    const estimatedGas = await contract.methods.makeOffer(nftId, expirationTime, nft.contractAddress).estimateGas({ from: getAllSessionData().account, value: amount });
                    console.log("Estimated Gas:", estimatedGas);
                    await new Promise((resolve, reject) => {
                        contract.methods.makeOffer(nftId, expirationTime, nft.contractAddress).send({
                            from: getAllSessionData().account,
                            value: amount,
                            gas: estimatedGas,
                        })
                            .on('transactionHash', (hash) => {
                                console.log('Transaction Hash:', hash);
                            })
                            .on('receipt', (receipt) => {
                                console.log('Receipt:', receipt);

                                let arr = [];
                                arr.push({
                                    offerAmount: amount,
                                    offerer: getAllSessionData().account,
                                });



                                let payload = { "nftTransaction": { "collectionAddress": props.match.params.collectionId, "tokenId": nft.id, "fromUserUuid": getAllSessionData().uuid, "nftName": nft.metadata.name, "fromUserAddress": getAllSessionData().account, "amount": offerPrice, "currency": "ETH", "transactionHash": receipt.transactionHash, "expiredOn": offerExpires } }

                                callAPI('post', NFTAPIBASENAME + '/nft/market/createNftOffer', payload, true).then((res) => {
                                    let response = res.data;
                                    console.log(response);
                                    if (response.error.error_data != 0) {
                                        showToast('error', response.error.error_msg)
                                    } else {

                                    }
                                }, (error) => {
                                    showHttpError(error)
                                })
                                setNftOffers(arr)
                                setShowLoader(false)
                                setInitiateMakeOffer(false)
                                document.getElementById('offerPrice').value = '';
                                getNftDetails(props.match.params.collectionId, props.match.params.nftId)
                                getOtherNftFromSameCollection(props.match.params.collectionId)
                                resolve();
                                showToast('success', 'Offer placed with amount ' + offerPrice + 'ETH')
                            })
                            .on('error', (error) => {
                                setShowLoader(false)
                                showToast('error', 'Error making offer:' + error);
                                if (error.code === 4001) {
                                    showToast('error', "Transaction rejected by the user.");
                                } else {
                                    showToast('error', 'Error making offer:' + error);
                                }
                                reject(error);
                            });
                    });
                } catch (error) {
                    setShowLoader(false)
                    showToast('error', 'Error making offer:' + error);
                    if (error.code === 4001) {
                        showToast('error', "Transaction rejected by the user.");
                    } else {
                        showToast('error', `Unexpected error: ${error.message}`);
                    }
                }

            } else {
                handleLogout()
                setShowLoader(false)
                showToast('error', 'Your session has expired, please login again');
            }

        } else {
            showToast('error', 'Please provide a valid offer price & duration');
        }

    }

    /* Method defination for cheking ownership  */
    const checkTokenOwnership = async (contractAddress, tokenId) => {

        //let contractAddress='0x850a7C982a8A70927F9D497696a0E63eAcDf6b56';

        const graphqlQuery = `
              {
                nfts(where: { id: "${tokenId}" }) {
                  owner
                }
              }
            `
        const graphqlResponse = await fetch('https://api.studio.thegraph.com/query/108358/paybito_nft_marketplace/v0.0.1', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ query: graphqlQuery }),
        });
        const graphqlData = await graphqlResponse.json();
        const graphOwner = graphqlData.data.nfts[0]?.owner.toLowerCase();
        console.log('Graphql Owner..', graphOwner);
        const response = await fetch(
            `https://deep-index.moralis.io/api/v2/nft/${contractAddress}/${tokenId}/owners?chain=eth`,
            {
                headers: { 'X-API-Key': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJub25jZSI6IjVlOGU2NDcyLTUyZDItNGQ0YS1hYmM3LTRkODc3OGU3MTY0OSIsIm9yZ0lkIjoiNDM5NDcxIiwidXNlcklkIjoiNDUyMTI4IiwidHlwZSI6IlBST0pFQ1QiLCJ0eXBlSWQiOiIzZDhjMmUwNC01YmM2LTQyMDQtYmNmOS1iOTkxZDFkYjcxYmIiLCJpYXQiOjE3NDM2Nzk1NjQsImV4cCI6NDg5OTQzOTU2NH0.mH9Y6oarw1ZQ8oq_bWCNOCYZsYaUnNk9h5IRvLDrGPM' }
            }
        );
        const data = await response.json();
        console.log(data);
        const isOwner = data.result.length > 0 && data.result[0].owner_of.toLowerCase() === graphOwner;

        if (isOwner) {
            console.log("Ownership Verified: The wallet owns this NFT.");
            return true;
        } else {
            showToast('error', "Ownership Invalid: The wallet does not own this NFT.");
            return false;
        }

    }

    /* method defination for updating sale price */
    const updateSalePrice = async (contractAddress, tokenId, newPrice) => {
        if (! await checkTokenOwnership(contractAddress, tokenId)) {
            showToast('error', "You are currently not holding the NFT");
            return;
        }


        let contract = await getBlockChainContract();

        if (!contract) {
            showToast('error', 'Contract is not initialized');
            return;
        }

        try {
            setShowLoader(true);

            // Convert new price to Wei
            const priceInWei = web3.utils.toWei(newPrice.toString(), 'ether');

            // Estimate gas
            const estimatedGas = await contract.methods.updateSalePrice(tokenId, priceInWei, contractAddress).estimateGas({
                from: getAllSessionData().account,
            });

            console.log("Estimated Gas:", estimatedGas);

            await new Promise((resolve, reject) => {
                contract.methods.updateSalePrice(tokenId, priceInWei, contractAddress).send({
                    from: getAllSessionData().account,
                    gas: estimatedGas,
                })
                    .on('transactionHash', (hash) => {
                        console.log('Transaction Hash:', hash);
                    })
                    .on('receipt', (receipt) => {
                        console.log('Receipt:', receipt);
                        setShowLoader(false);
                        showToast('success', "Sale price updated successfully!");
                        getNftDetails(props.match.params.collectionId, props.match.params.nftId)
                        getOtherNftFromSameCollection(props.match.params.collectionId)
                        resolve();
                    })
                    .on('error', (error) => {
                        setShowLoader(false);
                        if (error.code === 4001) {
                            console.log('Transaction rejected by user.');
                            showToast('error', "Transaction rejected by the user.");
                        } else {
                            console.error('Error updating sale price:', error);
                            showToast('error', `Unexpected error: ${error.message}`);
                        }
                        reject(error);
                    })
                    .catch((error) => {
                        setShowLoader(false);
                        if (error.code === 4001) {
                            console.log('User denied transaction signature.');
                            showToast('error', "Transaction rejected by the user.");
                        } else {
                            console.error('Error in sending transaction:', error);
                            showToast('error', `Unexpected error: ${error.message}`);
                        }
                        reject(error);
                    });
            });
        } catch (error) {
            setShowLoader(false);
            showToast('error', 'Error updating sale price :', error);
            if (error.code === 4001) {
                console.log('User denied transaction signature');
                showToast('error', "Transaction rejected by the user.");
            } else {
                showToast('error', `Unexpected error: ${error.message}`);
            }
        }
    };


    /* method defination for add for sale listing */
    let handleAddForSale = async () => {
        let salePrice = document.getElementById('salePrice').value;
        let expirationTime = Math.floor(new Date(expiredValue).getTime() / 1000);

        // let saleDuration = document.getElementById('saleDuration').value;




        if (salePrice != '' /* && saleDuration != '' */) {

            let isSessionActive = await isUserSessionActive();
            if (isSessionActive.isActive) {
                let contract = await getBlockChainContract();
                if (!contract) {
                    showToast('error', 'Contract is not initialized');
                    return;
                }
                const price = web3.utils.toWei(salePrice, 'ether');
                try {
                    setShowLoader(true)


                    if (! await checkTokenOwnership(nft.contractAddress, nft.id)) {
                        showToast('error', "You are currently not holding the NFT");
                        return;
                    }


                    const Web3 = new web3(window.ethereum);
                    console.log('Contract Address..' + nft.contractAddress);
                    if (nft.contractAddress.toLowerCase() != '0x850a7C982a8A70927F9D497696a0E63eAcDf6b56'.toLowerCase()) {
                        const contractInstance = new Web3.eth.Contract(ERC721ABI, nft.contractAddress);

                        let approvedAddress = await contractInstance.methods
                            .getApproved(nft.id)
                            .call();

                        console.log('Approved contract address for the token..', approvedAddress);

                        if (approvedAddress === '0x0000000000000000000000000000000000000000') {
                            console.log("Token not approved, requesting approval...");


                            // If not approved, set approval for all tokens in this collection
                            const approvalTx = await contractInstance.methods
                                .approve('0x850a7C982a8A70927F9D497696a0E63eAcDf6b56', nft.id)
                                .send({ from: getAllSessionData().account });

                            console.log("Approval successful for token:", nft.id);
                        }

                        approvedAddress = await contractInstance.methods
                            .getApproved(nft.id)
                            .call();

                        console.log('Approved contract address for the token..', approvedAddress);

                    }



                    const estimatedGas = await contract.methods
                        .listItemForSale(nft.id, price, expirationTime, nft.contractAddress)
                        .estimateGas({ from: getAllSessionData().account });



                    await new Promise((resolve, reject) => {
                        contract.methods.listItemForSale(nft.id, price, expirationTime, nft.contractAddress).send({
                            from: getAllSessionData().account,
                            gas: estimatedGas,
                        })
                            .on('transactionHash', (hash) => {
                                console.log('Transaction Hash:', hash);
                            })
                            .on('receipt', (receipt) => {
                                console.log('Receipt:', receipt);
                                let payload = { "nftTransaction": { "collectionAddress": props.match.params.collectionId, "tokenId": nft.id, "nftName": nft.metadata.name, "fromUserUuid": getAllSessionData().uuid, "fromUserAddress": getAllSessionData().account, "amount": document.getElementById('salePrice').value, "currency": "ETH", "transactionHash": receipt.transactionHash, "expiredOn": expiredValue } }

                                callAPI('post', NFTAPIBASENAME + '/nft/market/createNftSale', payload, true).then((res) => {
                                    let response = res.data;
                                    console.log(response);
                                    if (response.error.error_data != 0) {
                                        showToast('error', response.error.error_msg)
                                    } else {

                                    }
                                }, (error) => {
                                    showHttpError(error)
                                })
                                setInitiateAddForSale(false)
                                setShowListForSaleSuccessMetaMask(true);
                                document.getElementById('listingPrice').innerHTML = salePrice
                                setShowLoader(false)
                                resolve();
                            })
                            .on('error', (error) => {
                                setShowLoader(false)
                                if (error.code === 4001) {
                                    console.log('Transaction rejected by user.');
                                    showToast("error", "Transaction rejected by the user.");
                                } else {
                                    showToast('error', 'Error listing NFT for sale:' + error);
                                    showToast("error", `Unexpected error: ${error.message}`);
                                }
                                reject(error);
                            })
                            .catch((error) => {
                                setShowLoader(false)
                                if (error.code === 4001) {
                                    console.log('User denied transaction signature.');
                                    showToast("error", "Transaction rejected by the user.");
                                } else {
                                    showToast('error', 'Error in sending transaction:' + error);
                                    showToast("error", `Unexpected error: ${error.message}`);
                                }
                                reject(error);
                            });
                    });


                    getNftDetails(props.match.params.collectionId, props.match.params.nftId)
                    getOtherNftFromSameCollection(props.match.params.collectionId)
                } catch (error) {
                    setShowLoader(false)
                    showToast('error', 'Error listing NFT for sale (catch block):' + error);
                    if (error.code === 4001) {
                        showToast('error', 'User denied transaction signature');
                        showToast('error', "Transaction rejected by the user.");
                    } else {
                        showToast('error', `Unexpected error: ${error.message}`);
                    }

                }
            } else {
                handleLogout()
                setShowLoader(false)
                showToast('error', 'Your session has expired, please login again');
            }
        } else {
            showToast('error', 'Please provide a valid sale price');
        }

    }

    /* Method defination for handle add ETh */
    let handleAddEth = () => {
        setInitiateMakeOffer(false)
        clearInterval(offerStartInterval)
        window.open(localStorage.getItem('nftBrokerDomain') + '/basic', '_blank', 'noreferrer');
    }

    /* Method defination for deleting offer */
    let handleDeleteOffer = async (tokenId,amount) => {
        let contract = await getBlockChainContract();
        let isSessionActive = await isUserSessionActive();
        if (isSessionActive.isActive) {
            setShowLoader(true)
            if (!contract) {
                showToast('error', 'Contract is not initialized');
                setShowLoader(false)
                return;
            }
            try {
                await contract.methods.withdrawOffer(tokenId, nft.contractAddress).send({ from: getAllSessionData().account });
                let payload = { "nftTransaction": { "collectionAddress": props.match.params.collectionId, "tokenId": props.match.params.nftId, "toUserUuid": getAllSessionData().uuid, "toUserAddress": getAllSessionData().account, "amount": amount, "status": "0", "commissionRate": localStorage.getItem(localStorage.getItem('nftBrokerExchangeName') + '_nft_' + 'commission_rate') } }
                callAPI('post', NFTAPIBASENAME + '/nft/market/updateNftOfferNew', payload, true).then((res) => {
                    let response = res.data;
                    console.log(response);
                    if (response.error.error_data != 0) {
                        showToast('error', response.error.error_msg)
                    } else {

                    }
                }, (error) => {
                    showHttpError(error)
                })
                setShowLoader(false)
                showToast('success', 'Your NFT offer has been successfully deleted')
                getNftDetails(props.match.params.collectionId, props.match.params.nftId);
            } catch (error) {
                setShowLoader(false)
                showToast('error', 'Error withdrawing offer:' + error);
            }
        } else {
            handleLogout()
            setShowLoader(false)
            showToast('error', 'Your session has expired, please login again');
        }

    }

    /* Method defination for updating commission price */
    const updateCommissionRate = async () => {
        let contract = await getBlockChainContract();
        setShowLoader(true)
        if (!contract) {
            showToast('error', 'Contract is not initialized or new commission rate is missing');
            setShowLoader(false)
            return;
        }
        try {
            await contract.methods.setCommissionRate(commissionRate).send({ from: getAllSessionData().account });
            fetchCommissionRate(); // Refresh the commission rate after update
            setCommissionRate(0); // Clear the input
            document.getElementById('commissionRateField').value = ''
            setShowLoader(false)
        } catch (error) {
            setShowLoader(false)
            showToast('error', 'Error in accepting floor bid:' + error);
            if (error.code === 4001) {
                showToast('error', "Transaction rejected by the user.");
            } else {
                showToast('error', `Unexpected error: ${error.message}`);
            }
        }
    };

    /* Method defination for accepting floor bid */
    const handleAcceptFloorBid = async () => {
        let contract = await getBlockChainContract();
        setShowLoader(true)
        if (!contract) {
            showToast('error', 'Contract is not initialized');
            setShowLoader(false)
            return;
        }
        try {
            // Estimate gas
            const estimatedGas = await contract.methods
                .acceptFloorBid(props.match.params.nftId, props.match.params.collectionId, nft.contractAddress)
                .estimateGas({ from: getAllSessionData().account });

            console.log("Estimated Gas for accepting floor bid:", estimatedGas);

            await new Promise((resolve, reject) => {
                contract.methods.acceptFloorBid(props.match.params.nftId, props.match.params.collectionId, nft.contractAddress).send({
                    from: getAllSessionData().account,
                    gas: estimatedGas,
                })
                    .on('transactionHash', (hash) => {
                        console.log('Transaction Hash:', hash);
                        setShowLoader(false)
                    })
                    .on('receipt', (receipt) => {
                        console.log('Transaction Receipt:', receipt);
                        setShowLoader(false)
                        showToast('success', "Your floor bid has been successfully accepted");
                        getNftDetails(props.match.params.collectionId, props.match.params.nftId) // Refresh UI data
                        resolve();
                    })
                    .on('error', (error) => {
                        setShowLoader(false)
                        if (error.code === 4001) {
                            console.log('Transaction rejected by user.');
                            showToast('error', "Transaction rejected by the user.");
                        } else {
                            showToast('error', 'Error accepting floor bid:' + error);
                            showToast('error', `Unexpected error: ${error.message}`);
                        }
                        reject(error);
                    });
            });
        } catch (error) {
            setShowLoader(false)
            showToast('error', 'Error in accepting floor bid:' + error);
            if (error.code === 4001) {
                showToast('error', "Transaction rejected by the user.");
            } else {
                showToast('error', `Unexpected error: ${error.message}`);
            }
        }
    }
    /* Method defination for deleting offer */
    let handleDeleteSaleListing = async () => {
        let contract = await getBlockChainContract();
        let isSessionActive = await isUserSessionActive();
        if (isSessionActive.isActive) {
            setShowLoader(true)
            if (!contract) {
                showToast('error', 'Contract is not initialized');
                setShowLoader(false)
                return;
            }
            if (! await checkTokenOwnership(nft.contractAddress, nft.id)) {
                showToast('error', "You are currently not holding the NFT");
                return;
            }

            try {
                await contract.methods.delistItem(nft.id, nft.contractAddress).send({ from: getAllSessionData().account });
                let payload = { "nftTransaction": { "collectionAddress": props.match.params.collectionId, "tokenId": props.match.params.nftId, "fromUserUuid": getAllSessionData().uuid, "fromUserAddress": getAllSessionData().account } }


                callAPI('post', NFTAPIBASENAME + '/nft/market/delistNftSale', payload, true).then((res) => {
                    let response = res.data;
                    console.log(response);
                    if (response.error.error_data != 0) {
                        showToast('error', response.error.error_msg)
                    } else {

                    }
                }, (error) => {
                    showHttpError(error)
                })
                showToast('success', 'NFT delisted successfully');
                getNftDetails(props.match.params.collectionId, props.match.params.nftId)
                getOtherNftFromSameCollection(props.match.params.collectionId)

            } catch (error) {
                setShowLoader(false)
                console.log(error);
                showToast('error', 'Error withdrawing listing:' + error);
            }
        } else {
            handleLogout()
            setShowLoader(false)
            showToast('error', 'Your session has expired, please login again');
        }

    }

    /* Method defination for updating the offers */
    let updateOffer = async (status, amount) => {
        //status 1 for approve 2 for reject
        let contract = await getBlockChainContract();
        let isSessionActive = await isUserSessionActive();
        if (isSessionActive.isActive) {
            if (!contract) return;
             if (getAllSessionData().isLoggedInMetaMask !== 'true') {
                    showToast('error', 'Please login with MetaMask');
                    return;
                  }
            if (status == 1) {
                try {
                    setShowLoader(true)
                    const estimatedGas = await contract.methods
                        .acceptOffer(nft.id, nft.contractAddress)
                        .estimateGas({ from: getAllSessionData().account });
                    await new Promise((resolve, reject) => {
                        console.log('in promise')
                        contract.methods.acceptOffer(nft.id, nft.contractAddress)
                            .send({ from: getAllSessionData().account, gas: estimatedGas })
                            .on('transactionHash', (hash) => {
                               
                                console.log('Transaction Hash:', hash);
                            })
                            .on('receipt', (receipt) => {
                                console.log(receipt)
                                setShowLoader(false)
                                let payload = { "nftTransaction": { "collectionAddress": props.match.params.collectionId, "tokenId": props.match.params.nftId, "toUserUuid": getAllSessionData().uuid, "toUserAddress": getAllSessionData().account, "amount": amount, "status": "1", "commissionRate": localStorage.getItem(localStorage.getItem('nftBrokerExchangeName') + '_nft_' + 'commission_rate') } }
                                callAPI('post', NFTAPIBASENAME + '/nft/market/updateNftOfferNew', payload, true).then((res) => {
                                    let response = res.data;
                                    console.log(response);
                                    if (response.error.error_data != 0) {
                                        showToast('error', response.error.error_msg)
                                    } else {

                                    }
                                }, (error) => {
                                    showHttpError(error)
                                })
                                resolve()
                                showToast('success', 'Offer approved successfully')
                                getNftDetails(props.match.params.collectionId, props.match.params.nftId);


                            })
                            .on('error', (error) => {
                                console.log(error)
                                setShowLoader(false)
                                // showToast('error', 'Error Creating collection:' + error);
                                if (error.code === 4001) {
                                    showToast('error', "Transaction rejected by the user.");
                                } else {
                                    showToast('error', 'Error Accepting offer:' + error);
                                }
                                reject(error);
                            })
                            .catch((error) => {
                                setShowLoader(false)
                                if (error.code === 4001) {
                                    console.log('User denied transaction signature.');
                                    showToast("error", "Transaction rejected by the user.");
                                } else {
                                    showToast('error', 'Error in sending transaction:' + error);
                                    showToast("error", `Unexpected error: ${error.message}`);
                                }
                                reject(error);
                            });
                    });






                } catch (error) {
                    setShowLoader(false)
                    showToast('error', 'Error accepting offer:' + error);
                }
            } else {
                try {
                    setShowLoader(false)
                    const estimatedGas = await contract.methods
                        .withdrawOffer(nft.id, nft.contractAddress)
                        .estimateGas({ from: getAllSessionData().account });
                    await new Promise((resolve, reject) => {
                        console.log('in promise')
                        contract.methods.withdrawOffer(nft.id, nft.contractAddress)
                            .send({ from: getAllSessionData().account, gas: estimatedGas })
                            .on('transactionHash', (hash) => {
                                setShowLoader(false)
                                console.log('Transaction Hash:', hash);
                            })
                            .on('receipt', (receipt) => {
                                console.log(receipt)
                                let payload = { "nftTransaction": { "collectionAddress": props.match.params.collectionId, "tokenId": props.match.params.nftId, "toUserUuid": getAllSessionData().uuid, "toUserAddress": getAllSessionData().account, "amount": amount, "status": "0", "commissionRate": localStorage.getItem(localStorage.getItem('nftBrokerExchangeName') + '_nft_' + 'commission_rate') } }

                                callAPI('post', NFTAPIBASENAME + '/nft/market/updateNftOfferNew', payload, true).then((res) => {
                                    let response = res.data;
                                    console.log(response);
                                    if (response.error.error_data != 0) {
                                        showToast('error', response.error.error_msg)
                                    } else {

                                    }
                                }, (error) => {
                                    showHttpError(error)
                                })
                                resolve()
                                showToast('success', 'Your NFT offer has been successfully rejected')
                                getNftDetails(props.match.params.collectionId, props.match.params.nftId);


                            })
                            .on('error', (error) => {
                                console.log(error)
                                setShowLoader(false)
                                // showToast('error', 'Error Creating collection:' + error);
                                if (error.code === 4001) {
                                    showToast('error', "Transaction rejected by the user.");
                                } else {
                                    showToast('error', 'Error Rejecting Offer:' + error);
                                }
                                reject(error);
                            })
                            .catch((error) => {
                                setShowLoader(false)
                                if (error.code === 4001) {
                                    console.log('User denied transaction signature.');
                                    showToast("error", "Transaction rejected by the user.");
                                } else {
                                    showToast('error', 'Error in sending transaction:' + error);
                                    showToast("error", `Unexpected error: ${error.message}`);
                                }
                                reject(error);
                            });
                    });

                } catch (error) {
                    setShowLoader(false)
                    showToast('error', 'Error rejecting offer:' + error);
                }
            }
        } else {
            handleLogout()
            setShowLoader(false)
            showToast('error', 'Your session has expired, please login again');
        }

    }

    /* method defination for handle transfer */
    let handleTransfer = () => {
        let address = document.getElementById('addressForTransfer').value;
        let payload = { "userUuid": getAllSessionData().uuid, "toValue": address, "entityId": nft.nftId, "networkName": "ETHEREUM" }
        setShowLoader(true)
        callAPI('post', NFTAPIBASENAME + '/nft/market/transferNft', payload, true).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                showToast('success', 'NFT transfer successfully');
                setTimeout(() => {
                    getNftDetails(props.match.params.id)
                    getAllSaleListingOfNft(props.match.params.id)
                }, 2000);

            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })
    }

    /* Method defination for handle transfer to metamask */
    const handleTransferThroughMetamask = async () => {
        let tokenId = nft.id
        let transferToAddress = document.getElementById('addressToTransferForMetaMask').value;
        if (getAllSessionData() != undefined && getAllSessionData() != null) {
            let account = getAllSessionData().account;
            if (transferToAddress === "") {
                showToast('error', 'Please provide a address to transfer')
            } else {
                setShowLoader(true)
                let contract = await getBlockChainContract();

                if (!contract) return;
                 if (getAllSessionData().isLoggedInMetaMask !== 'true') {
                    showToast('error', 'Please login with MetaMask');
                    return;
                  }

                if (! await checkTokenOwnership(nft.contractAddress, nft.id)) {
                    showToast('error', "You are currently not holding the NFT");
                    return;
                }
                try {


                    console.log('Contract Address..' + nft.contractAddress);
                    if (nft.contractAddress.toLowerCase() != '0x850a7C982a8A70927F9D497696a0E63eAcDf6b56'.toLowerCase()) {
                        const Web3 = new web3(window.ethereum);
                        const contractInstance = new Web3.eth.Contract(ERC721ABI, nft.contractAddress);

                        let approvedAddress = await contractInstance.methods
                            .getApproved(tokenId)
                            .call();

                        console.log('Approved contract address for the token..', approvedAddress);

                        if (approvedAddress === '0x0000000000000000000000000000000000000000') {
                            console.log("Token not approved, requesting approval...");


                            // If not approved, set approval for all tokens in this collection
                            const approvalTx = await contractInstance.methods
                                .approve('0x850a7C982a8A70927F9D497696a0E63eAcDf6b56', tokenId)
                                .send({ from: account });

                            console.log("Approval successful for token:", tokenId);
                        }

                        approvedAddress = await contractInstance.methods
                            .getApproved(tokenId)
                            .call();

                        console.log('Approved contract address for the token..', approvedAddress);

                    }


                    await contract.methods.transferNFT(transferToAddress, tokenId, nft.contractAddress).send({ from: getAllSessionData().account });
                    getNftDetails(props.match.params.collectionId, props.match.params.nftId)
                    setTransferForMetaMaskSuccess(true);
                    document.getElementById('addressToTransferForMetaMask').value = '';
                } catch (error) {
                    setShowLoader(false)
                    console.log(error.message)
                    if (error.message.indexOf('must pass "address" validation') != -1) {
                        showToast('error', 'Please provide a valid address')
                    } else {
                        showToast('error', 'Error transferring NFT:' + error);
                    }
                }

                //let payload = { "entityId": nft.collectionId }
                /* callAPI('post', NFTAPIBASENAME + '/nft/market/public/getContractAbiById', payload, false).then((res) => {
                    let response = res.data;
                    setShowLoader(false);
                    console.log(response);
                    if (response.error.error_data != 0) {
                        showToast('error', response.error.error_msg)
                    } else {
                        let resp = response;
                        //Calling the metamask plugin
                        const ABI = JSON.parse(resp.contractAbi);
                        const CONTRACT_ADDRESS = resp.address;
                        console.log(ABI, CONTRACT_ADDRESS)
                        const Web3 = new web3(window.ethereum);
                        var myContract = new Web3.eth.Contract(ABI, CONTRACT_ADDRESS, { from: account });
                        console.log(myContract);
                        setShowLoader(true)
                        myContract.methods.setApprovalForAll(transferToAddress, true).send({ from: account, gas: 300000 }).then((rps) => {
                            console.log('On approval success', rps)
                            myContract.methods.transferFrom(account, transferToAddress, tokenId).send({ from: account, gas: 300000 })
                                .then((res) => {
                                    console.log('On Success', res);
                                    setMetaMaskTransferId(res.transactionHash)
                                    let payload = {
                                        "address": nft.contractAddress,
                                        "toValue": transferToAddress,
                                        "fromValue": res.from,
                                        "amount": "0",
                                        "entityId": nft.nftId,
                                        "userUuid": getAllSessionData().uuid,
                                        "transaction": res.transactionHash
                                    }
                                    callAPI('post', NFTAPIBASENAME + '/nft/market/transferExternalNft', payload, true).then((res) => {
                                        let response = res.data;
                                        setShowLoader(false);
                                        console.log(response);
                                        if (response.error.error_data != 0) {
                                            showToast('error', response.error.error_msg)
                                        } else {
                                            setTransferForMetaMaskSuccess(true);
 
                                        }
 
                                    }, (error) => {
                                        setShowLoader(false);
                                        showHttpError(error)
                                    })
 
                                })
                                .catch((error) => {
                                    setTransferForMetaMaskPopup(false);
                                    setTransferForMetaMaskSuccess(false);
                                    console.log(error);
                                    showToast('error', 'Your transfer process has been rejected' + error)
                                    setShowLoader(false)
                                })
 
                        }).catch((error) => {
                            setTransferForMetaMaskPopup(false);
                            setTransferForMetaMaskSuccess(false);
                            console.log(error);
                            showToast('error', 'Your approval process has been rejected ' + error)
                            setShowLoader(false)
                        })
 
 
                    }
 
                }, (error) => {
                    setShowLoader(false);
                    showHttpError(error)
                }) */


            }
        } else {
            showToast('error', "Please login with Meta Mask to continue")
        }




    }
    /* Method defination for handle transfer to metamask */
    const handleListForSaleThroughMetamask = async () => {
        let tokenId = nft.nftId
        let transferToAddress = document.getElementById('addressToListForSaleForMetaMask').value;
        if (getAllSessionData() != undefined && getAllSessionData() != null) {
            let account = getAllSessionData().account;
            if (transferToAddress === "") {
                showToast('error', 'Please provide a address to transfer')
            } else {
                setShowLoader(true)
                // get ABI from API from contract Address
                //const ABIs = [];
                //Calling the metamask plugin
                // const Web3 = new web3(window.ethereum);
                // var myContract = new Web3.eth.Contract(ABIs, "0x2953399124F0cBB46d2CbACD8A89cF0599974963", { from: account });


                // account, transferToAddress, tokenId
                // myContract.methods.setApprovalForAll(transferToAddress, true).send({ from: account, gas: 300000 })
                //     .then((res) => {
                //         console.log(res);
                //         listForMetaMask(transferToAddress, tokenId);
                //     })
                //     .catch((error) => {
                //         console.log("Error in send NFT Token"+ error);
                //         showToast('error', "Error in send NFT Token")
                //     })
            }


        } else {
            showToast('error', "Please login with Meta Mask to continue")
        }




    }

    /* Method defination for listing of NFT for metamask */
    const listForMetaMask = async (param1, param2) => {
        const OPENSEA_API_KEY = "2b540527928e48799c9d7df4908021f5";
        const WALLET_PRIV_KEY = "0x4386a267866bd48b613126820f7fb6022426dee8664efb3af409c3cab3262428";


        const provider = new ethers.providers.JsonRpcProvider("https://eth-sepolia.g.alchemy.com/v2/z8AmxQJ-R1lH7HeGgRU8lsIOhTJhELU5"
        );


        const walletMainnet = new ethers.Wallet(
            WALLET_PRIV_KEY,
            provider
        );


        const WALLET_ADDRESS = walletMainnet.address;
        console.log('WALLET_ADDRESS', WALLET_ADDRESS)
        const sdk = new OpenSeaSDK(walletMainnet, {
            chain: Chain.Polygon,
            apiKey: OPENSEA_API_KEY,
        },
            (line) => console.info(`MAINNET: ${line}`),
        );
        let tokenAddress = param1;
        let tokenId = param2;
        let listingAmount = nftPriceDetails.salePrice;


        const listing = {
            accountAddress: WALLET_ADDRESS,
            startAmount: listingAmount,
            asset: {
                tokenAddress: tokenAddress,
                tokenId: tokenId,
            }
        };


        try {
            const signer = walletMainnet.connect(provider);
            const response = await sdk.createListing(listing, signer);
            // const response = await sdk.createListing(listing);
            showToast('success', "Successfully created a listing with orderHash:", response.orderHash);
        } catch (error) {
            console.log("Error in createListing:" + error)
            showToast('error', "Error in createListing");
        }


    }

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        getNftDetails(props.match.params.collectionId, props.match.params.nftId)
        getOtherNftFromSameCollection(props.match.params.collectionId)

        
    }, []);

    return (
        <Fragment>
            <Header />
            <div className="shop-detail-box-main">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-5 col-lg-5 col-md-6">
                            <div id="carousel-example-1" className="single-product-slider carousel slide" data-ride="carousel">
                                <div className="carousel-inner" role="listbox">
                                    {console.log('METADATA RENDERING => ',nft.metadata)}
                                    {nft.metadata != undefined && <div className="carousel-item active"> <img className="d-block w-100" src={nft.metadata.image.replace('ipfs://', 'https://ipfs.io/ipfs/')} alt={nft.metadata.name} /> </div>}

                                </div>


                            </div>
                        </div>
                        <div className="col-xl-7 col-lg-7 col-md-6">
                            <div className="single-product-details">
                                <div className="row">
                                    <div className="col-md-8">
                                        {nft.metadata != undefined && <h2>{nft.metadata.name} </h2>}
                                    </div>
                                    <div className="col-md-4">

                                    </div>
                                </div>
                                <p>Owned by <Link to={`/profile/${nft.owner}`}>{nft.owner}</Link></p>

                                {nft.price > 0 && nft.price != null && <p>Expires on :  {nft.isExpired ? <span style={{ color: 'red' }}>Expired ({moment(nft.expirationTime.toString() * 1000).format('YYYY-MM-DD hh:mm:ss')})</span> : !nft.isExpired && nft.expirationTime != null && nft.expirationTime != undefined ? moment(nft.expirationTime.toString() * 1000).format('YYYY-MM-DD hh:mm:ss') : '-'}</p>}

                                <h5> {nft.price > 0 && nft.price != null ? web3.utils.fromWei(nft.price.toString(), 'ether') + 'ETH' : 'Not For Sale'} {nft.price > 0 && nft.price != null && <span className="usd-text"> {commission} ETH commission goes to MarketPlace owner</span>}</h5>

                                {nft.price > 0 && nft.price != null && nft.owner == getAllSessionData().account &&
                                    <div className="row">
                                        <div className="col-md-8">
                                            <input type="text" className="form-control" id="updateSalePriceField" placeholder="Enter Updated Sale Price" onKeyUp={(e) => {
                                                let value = e.target.value;
                                                let reg = /^\d+(\.\d{0,6})?$/
                                                console.log(value)
                                                if (!value.match(reg)) {
                                                    e.target.value = value.slice(0, -1);
                                                }
                                            }} />
                                        </div>
                                        <div className="col-md-4">
                                            <button type="button" className="btn btn-primary" onClick={() => {
                                                let newPrice = document.getElementById('updateSalePriceField').value;
                                                newPrice != '' ? updateSalePrice(nft.contractAddress, nft.id, newPrice) : showToast('error', 'Please provide a valid sale price')
                                            }}>Update Sale Price</button>
                                        </div>
                                    </div>
                                }
                                {/*<p className="available-stock"><span>  <span className="ml-2"><i className="fa fa-eye" aria-hidden="true"></i> {totalViewed} views</span><span href="javascript:void(0)" className="ml-2">{nft.isFavourite == 1 ? <Fragment><a href={props.match.params.id} data-toggle="tooltip" data-placement="right" title="Remove from Favorites" onClick={(e) => {
                                        e.preventDefault(); removeFromFavorite(nft.nftId, () => { window.location.reload() })
                                    }}><i className="fa fa-solid fa-heart"></i></a></Fragment> : <Fragment><a href={props.match.params.id} data-toggle="tooltip" data-placement="right" title="Add to Favorites" onClick={(e) => {
                                        e.preventDefault(); addToFavorite(nft.nftId, () => { window.location.reload() })
                                    }}><i className="far fa-heart"></i></a></Fragment>} {nft.favouriteCount} favorites </span></span></p>*/}
                                <h4>Short Description:</h4>
                                {nft.metadata != undefined && <p>{nft.metadata.description}</p>}



                                <div className="price-box-bar">
                                    <div className="cart-and-bay-btn">
                                        {/* <a className="btn hvr-hover" data-fancybox-close="" href="#">Buy Now</a> */}
                                        {getAllSessionData() != null && nft.owner != undefined && <Fragment>
                                            {getAllSessionData().account.toLowerCase() == nft.owner.toLowerCase() ? <Fragment>{(nft.price == 0 || nft.price == null) && !nft.isExpired ? <button className="btn hvr-hover mr-2 " data-fancybox-close="" onClick={() => { openAddForSalePopup() }} disabled={getAllSessionData() == null}>List for sale</button> : (nft.price != 0 || nft.price != null) && nft.isExpired ? <button className="btn hvr-hover mr-2 " data-fancybox-close="" onClick={() => { handleDeleteSaleListing() }} >Delist</button> : <button className="btn hvr-hover mr-2 " data-fancybox-close="" onClick={() => { handleDeleteSaleListing() }} >Delist</button>}  <button className="btn hvr-hover mr-2 " onClick={() => {
                                                setTransferForMetaMaskPopup(true);
                                            }}> <i className="fa fa-solid fa-share"></i> Transfer</button>
                                            </Fragment> : <Fragment>
                                                {userOfferCount == 0 && <button className="btn hvr-hover mr-2" data-fancybox-close="" onClick={() => { openMakeOfferPopup() }}>Make an Offer</button>}
                                                <button className="btn hvr-hover mr-2" data-fancybox-close="" onClick={() => { buyNft() }} disabled={nft.price == 0 || nft.price == null}>Buy Now</button>

                                            </Fragment>}
                                        </Fragment>}

                                    </div>
                                </div>

                                {/*  <div className="add-to-btn">
                                        <div className="add-comp">
                                            <a className="btn hvr-hover" href="#"><i className="fas fa-heart"></i> Add to Favorites</a>
                                            <a className="btn hvr-hover" href="#"><i className="fas fa-sync-alt"></i> Add to Compare</a>
                                        </div>
                                        <div className="share-bar">
                                            <a className="btn hvr-hover" href="#"><i className="fab fa-facebook" aria-hidden="true"></i></a>
                                            <a className="btn hvr-hover" href="#"><i className="fab fa-google-plus" aria-hidden="true"></i></a>
                                            <a className="btn hvr-hover" href="#"><i className="fab fa-twitter" aria-hidden="true"></i></a>
                                            <a className="btn hvr-hover" href="#"><i className="fab fa-pinterest-p" aria-hidden="true"></i></a>
                                            <a className="btn hvr-hover" href="#"><i className="fab fa-whatsapp" aria-hidden="true"></i></a>
                                        </div>
                                    </div> */}

                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-xl-6 col-lg-6 col-md-6">
                            {/* <div className="single-product-details">
                                <h2><i className="fa fa-bookmark-o" aria-hidden="true"></i> Traits</h2>
                                <div>
                                    <div className="row">
                                        {nft.nftTraits != null && nft.nftTraits.map((trait) => (<div className="col-md-4" key={trait.traitName + Math.random()}>
                                            <div className="trait-list">
                                                <div>{trait.traitName}</div>
                                                <div>Value : {trait.traitValue}</div>
                                                

                                            </div>
                                        </div>))}

                                    </div>
                                </div>
                            </div> */}
                            <div className="single-product-details">
                                <h2><i className="fa fa-bookmark-o" aria-hidden="true"></i> Description</h2>
                                <div>
                                    {nft.metadata != undefined && <p>{nft.metadata.description}</p>}
                                </div>
                            </div>
                            <div className="single-product-details">
                                <h2><i className="fa fa-info-circle" aria-hidden="true"></i> Details</h2>
                                <div>
                                    <ul className="list-group">
                                        <li className="list-group-item"> <span>Contract Address :</span> {nft.contractAddress != undefined && nft.contractAddress}</li>
                                        <li className="list-group-item"> <span>Open original :</span> <a target="_blank" style={{ fontSize: '12px', fontWeight: '500' }} href={nft.metadata != undefined && nft.metadata.image.replace('ipfs://', 'https://ipfs.io/ipfs/')}>{nft.metadata != undefined && nft.metadata.image.replace('ipfs://', 'https://ipfs.io/ipfs/')}</a></li>
                                        {/*  <li className="list-group-item"><span>Token ID :</span> <span>{parseInt(nft.id)}</span></li> */}
                                        {/* <li className="list-group-item"><span>Token Standard :</span> <span>{nft.tokenType}</span></li>
                                        <li className="list-group-item"> <span>Chain :</span> <span>{nft.networkName}</span></li>
                                        <li className="list-group-item"><span>Created On :</span> <span>{nft.createdOn}</span></li>
                                        <li className="list-group-item"><span>Creator Earnings :</span> <span>{nft.createrEarning}</span></li> */}
                                    </ul>
                                    <div>






                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6">
                            <div className="single-product-details">
                                <h2> <i className="fa fa-line-chart" aria-hidden="true"></i> Price History</h2>
                            </div>
                            {/* <div className="single-product-details">
                                <h2> <i className="fa fa-tag" aria-hidden="true"></i> Listing</h2>
                                <div>
                                    <div className="table-responsive">
                                        <table className="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Price</th>
                                                    <th scope="col">USD Price</th>
                                                    <th scope="col">Quantity</th>
                                                    <th scope="col">Expiration</th>
                                                    <th scope="col">From</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {nftSaleListing.map((list) => (<tr>
                                                    <td>{list.salePrice} {list.currencyCode}</td>
                                                    <td>${list.saleUsdPrice}</td>
                                                    <td>1</td>
                                                    <td>in {list.duration}</td>
                                                    <td><a href="javascript:void(0)" >{list.userDetail}</a></td>
                                                    <td>
                                                        {getAllSessionData() != null && getAllSessionData().uuid == nft.ownerId ? <button className="btn btn-sm btn-danger" onClick={() => { handleDeleteSaleListing(list.nftSaleId) }}>Delete</button> : <button className="btn btn-sm btn-primary" onClick={() => {
                                                            handleBuyFromListing(list)
                                                        }}>Buy</button>
                                                        }
                                                    </td>
                                                </tr>))}

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div> */}
                            <div className="single-product-details">
                                <h2> <i className="fa fa-list" aria-hidden="true"></i>Offers</h2>
                                <div className="table-responsive">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th scope="col">Price</th>
                                                {/*  <th scope="col">USD Price</th> */}
                                                {/*  <th scope="col">Quantity</th> */}
                                                {/* <th scope="col">Floor Price</th> */}
                                                <th scope="col">Expiration</th>
                                                <th scope="col">From</th>
                                                {getAllSessionData() != null && <th scope="col">Action</th>}
                                            </tr>
                                        </thead>
                                        {nftOffers.length > 0 ?
                                            <tbody>
                                                {nftOffers.map((offer) => (offer.offerer != "0x0000000000000000000000000000000000000000" && <tr key={offer.offerer}>
                                                    <td>{web3.utils.fromWei(offer.offerAmount.toString(), 'ether')} ETH</td>
                                                    {/* <td>${offer.priceInUsd}</td> */}
                                                    {/* <td>1</td> */}
                                                    {/* <td>{offer.floorPrice}</td> */}
                                                    <td>{offer.offerExpiration != undefined && offer.offerExpiration != null && moment(offer.offerExpiration.toString() * 1000).format('YYYY-MM-DD hh:mm:ss')}</td>
                                                    <td><a href="javascript:void(0)" >{offer.offerer}</a></td>
                                                    {getAllSessionData() != null && offer.offerer.toLowerCase() == getAllSessionData().account.toLowerCase() && <td><button className="btn btn-danger" onClick={() => {
                                                        handleDeleteOffer(nft.id,web3.utils.fromWei(offer.offerAmount.toString(), 'ether'))
                                                    }}>Delete Offer</button></td>}
                                                    {getAllSessionData() != null && nft.owner != undefined && nft.owner.toLowerCase() == getAllSessionData().account.toLowerCase() && !offer.isExpired && <td><button className="btn btn-primary" onClick={() => {
                                                        updateOffer(1, web3.utils.fromWei(offer.offerAmount.toString(), 'ether'))
                                                    }}>Approve</button>{/* <button className="btn btn-danger ml-2" onClick={() => {
                                                        updateOffer(2, web3.utils.fromWei(offer.offerAmount.toString(), 'ether'))
                                                    }}>Reject</button> */}</td>}


                                                </tr>))}




                                            </tbody>
                                            : <tbody><tr><td colSpan={4}>No Offers placed yet</td></tr></tbody>}
                                    </table>
                                </div>
                            </div>
                            <div className="single-product-details" style={{ marginBottom: '34px' }}>
                                <h2> <i className="fa fa-list" aria-hidden="true"></i>Floor Bids</h2>
                                <div className="table-responsive">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th scope="col">Bid Amount</th>
                                                {/*  <th scope="col">USD Price</th> */}
                                                {/*  <th scope="col">Quantity</th> */}
                                                {/* <th scope="col">Floor Price</th> */}
                                                <th scope="col">Expiration</th>
                                                <th scope="col">From</th>
                                                {getAllSessionData() != null && <th scope="col">Action</th>}
                                            </tr>
                                        </thead>
                                        {nftOffers.length > 0 ?
                                            <tbody>
                                                {floorBids.map((offer) => (offer.bidder != "0x0000000000000000000000000000000000000000" && <tr key={offer.bidder}>
                                                    <td>{offer.bidAmount} ETH</td>
                                                    {/* <td>${offer.priceInUsd}</td> */}
                                                    {/* <td>1</td> */}
                                                    {/* <td>{offer.floorPrice}</td> */}
                                                    <td>{offer.expirationTime != undefined && offer.expirationTime != null && moment(offer.expirationTime.toString() * 1000).format('YYYY-MM-DD hh:mm:ss')}</td>
                                                    <td><a href="javascript:void(0)" >{offer.bidder}</a></td>
                                                    {getAllSessionData() != null && offer.bidder.toLowerCase() != getAllSessionData().account.toLowerCase() && <td><button type="button" className="btn btn-primary" onClick={() => {
                                                        handleAcceptFloorBid()
                                                    }}>Accept Bid</button></td>}



                                                </tr>))}




                                            </tbody>
                                            : <tbody><tr><td colSpan={4}>No Offers placed yet</td></tr></tbody>}
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

           



            {/* Start Notable section  */}
            <div className="products-box">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="title-all text-center">
                                <h1>More From This Collections</h1>

                            </div>
                        </div>
                    </div>


                    <div className="row special-list">

                        <AliceCarousel
                            mouseTracking
                            items={notableNftLists}
                            responsive={responsiveForSliders}
                            controlsStrategy="alternate"
                        />

                    </div>
                </div>
            </div>
            {/* End Notable section  */}

            {/* Make offer modal */}
            <Fragment>
                <div className={"modal " + (initiateMakeOffer ? 'show' : '')} tabIndex="-1" role="dialog" style={{ display: initiateMakeOffer ? 'block' : 'none', paddingRight: '17px', background: '#0000008c' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Make Offer</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setInitiateMakeOffer(false); }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row" style={{ marginBottom: '20px', padding: '0 177px 0 177px' }}>
                                    <div className="col-md-12">
                                        {nft.metadata != undefined && <img src={nft.metadata.image.replace('ipfs://', 'https://ipfs.io/ipfs/')} alt={nft.metadata.name} style={{ height: '100%', width: '100%' }} />}


                                    </div>

                                </div>
                                <div className="row">
                                    {nft.metadata != undefined && <span className="ml-2 col-md-12" style={{ fontSize: '20px', fontWeight: '700', textAlign: 'center' }}>{nft.metadata.name}</span>}
                                </div>
                                <div className="row">
                                    <div className="col-md-6">Balance</div>
                                    <div className="col-md-3"></div>
                                    <div className="col-md-3">{parseFloat(userBalance).toFixed(6)} ETH</div>
                                </div>
                                {/* <div className="row">
                                    <div className="col-md-6">Floor Price</div>
                                    <div className="col-md-3"></div>
                                    <div className="col-md-3">{nft.floorPrice} ETH</div>
                                </div> */}
                                {/* <div className="row">
                                    <div className="col-md-6">Best Offer</div>
                                    <div className="col-md-3"></div>
                                    <div className="col-md-3">{nft.bestPrice} ETH</div>
                                </div> */}
                                <div className="row">
                                    <label className="col-md-12">Amount</label>
                                    <div className="col-md-11">
                                        <input type="number" className="form-control" placeholder="Enter Offer amount" id="offerPrice" onKeyUp={(e) => {
                                            validateOfferPrice(e.target.value)
                                        }} />
                                    </div>
                                    <div className="col-md-1">
                                        ETH
                                    </div>
                                </div>
                                {!isValidOfferPrice && nft.price !== undefined && nft.price !== null ? <span className="col-md-12" style={{ color: 'red' }}>Amount should be greater than listing price {web3.utils.fromWei(nft.price.toString(), 'ether')} ETH</span> : !isValidOfferPrice && (nft.price == undefined || nft.price == null) ? <span className="col-md-12" style={{ color: 'red' }}>Amount should be greater than or equals to  0.0001 ETH</span> : ''}

                                <div className="row">
                                    <div className="col-md-12">
                                        <label>Expires on</label>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <DateTimePicker onChange={(date) => { handleOfferExpiredOn(date) }} value={offerExpires} style={{ width: '100%' }} />
                                    </div>

                                </div>
                                <div className="row mt-4 ml-2 mr-2">
                                    <button type="button" className="btn btn-primary col-md-12" onClick={() => { handleMakeAnOffer() }} disabled={!isValidOfferPrice}>Make Offer</button>
                                    <div className="col-md-2"></div>
                                    {/*  <button type="button" className="btn btn-secondary col-md-5" onClick={() => { handleAddEth() }}>Add ETH</button> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
            {/* Add for sale modal */}
            <Fragment>
                <div className={"modal " + (initiateAddForSale ? 'show' : '')} tabIndex="-1" role="dialog" style={{ display: initiateAddForSale ? 'block' : 'none', paddingRight: '17px', background: '#0000008c' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Add For Sale</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setInitiateAddForSale(false) }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">

                                <div className="row">
                                    <div className="col-md-11">
                                        <input type="number" className="form-control" placeholder="Enter amount" id="salePrice" onKeyUp={(e) => {
                                            let status = false
                                            /* if (parseFloat(e.target.value) > parseFloat(nft.floorPrice)) {
                                                status = true
                                            } else {
                                                status = false
                                            } */
                                            if (parseFloat(e.target.value) != '' && parseFloat(e.target.value) >= 0.0001) {
                                                status = true
                                            } else {
                                                status = false
                                            }
                                            setValidSalePrice(status)
                                        }} />
                                    </div>
                                    <div className="col-md-1">
                                        ETH
                                    </div>
                                </div>
                                {!isValidSalePrice && <div className="row">
                                    {/* <span className="col-md-12" style={{ color: 'red' }}>Amount should be greater than floor price {nft.floorPrice} ETH</span> */}
                                    <span className="col-md-12" style={{ color: 'red' }}>Please provide a valid amount</span>
                                </div>}
                                {/* <div className="row">
                                    <div className="col-md-12">
                                        <label>Duration</label>
                                    </div>
                                </div> */}
                                {/*  <div className="row">
                                    <div className="col-md-4">
                                        <select className="form-control" id="saleDuration">
                                            <option value="">Select Duration</option>
                                            {durations.map((duration) => (
                                                <option value={duration.durationId}>{duration.durationName}</option>
                                            ))}
                                        </select>
                                    </div>

                                </div> */}
                                <div className="row">
                                    <div className="col-md-12">
                                        <label>Expiry Date</label>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <DateTimePicker onChange={(date) => { handleExpiredValue(date) }} value={expiredValue} style={{ width: '100%' }} />
                                    </div>

                                </div>
                                <div className="row mt-4 ml-2 mr-2">
                                    <button type="button" className="btn btn-primary col-md-12" onClick={() => { handleAddForSale() }} disabled={!isValidSalePrice}>Add For Sale</button>
                                    <div className="col-md-2"></div>
                                    {/* <button type="button" className="btn btn-secondary col-md-5" onClick={() => { handleAddEth() }}>Add ETH</button> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
            {/* Transfer modal */}
            <Fragment>
                <div className={"modal " + (initiateTransfer ? 'show' : '')} tabIndex="-1" role="dialog" style={{ display: initiateTransfer ? 'block' : 'none', paddingRight: '17px', background: '#0000008c' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Transfer</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setInitiateTransfer(false) }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">

                                <div className="row">
                                    <div className="col-md-12">
                                        <input type="text" className="form-control" placeholder="Enter address" id="addressForTransfer" onKeyUp={(e) => {
                                            let status = false
                                            if (e.target.value != '') {
                                                status = true
                                            } else {
                                                status = false
                                            }
                                            setIsValidTransferAddress(status)
                                        }} />
                                    </div>

                                </div>
                                <div className="row">

                                </div>



                                <div className="row mt-4 ml-2 mr-2">
                                    <button type="button" className="btn btn-primary col-md-12" onClick={() => { handleTransfer() }} disabled={!isValidTransferAddress}>Transfer</button>
                                    <div className="col-md-2"></div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>

            {/* Confirmation modal before buying NFT */}
            <Fragment>
                <div className={"modal " + (showBuyConfirmationModal ? 'show' : '')} tabIndex="-1" role="dialog" style={{ display: showBuyConfirmationModal ? 'block' : 'none', paddingRight: '17px', background: '#0000008c' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className="row">
                                    <div className="col-md-12 d-flex  col-sm-12 modal-title">
                                        <h3 className="modal-title">Review Purchase</h3>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => {
                                            setShowBuyConfirmationModal(false);
                                            setIsChecked(false)
                                        }
                                        }>

                                            <span aria-hidden="true">&times;</span>
                                        </button>

                                    </div>
                                    <div className="col-sm-12 col-md-12">
                                        <p>
                                            <b>Review this information to ensure it's what you want to buy.</b>

                                        </p>
                                    </div>
                                </div>

                            </div>
                            <div className="modal-body">

                                <div className="row">
                                    <div className="col-md-12">
                                        <table className="table table-borderless">
                                            <tr>
                                                <td>
                                                    <b>NFT Name</b>
                                                </td>
                                                <td>
                                                    {nft.nftName}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><b>Creator</b></td>
                                                <td>{nft.creator}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Created Date</b></td>
                                                <td>{nft.createdOn}</td>
                                            </tr>

                                        </table>

                                    </div>
                                    <div className="col-md-1 col-sm-1 col-12">
                                        <input type="checkbox" onChange={() => {
                                            setIsChecked(!isChecked)
                                        }

                                        } checked={isChecked} />
                                    </div>
                                    <div className="col-md-11 col-sm-11 col-12">
                                        <label htmlFor="">I understand that {localStorage.getItem('nftBrokerExchangeName')} has not reviewed this collection and blockchain transactions are irreversible.</label>
                                    </div>


                                </div>
                                <div className="row">
                                    <div className="col-md-4"></div>
                                    <div className="col-md-4">
                                        <button className="btn btn-primary" disabled={!isChecked} onClick={() => {
                                            handleBuyFromListing(nftPriceDetails)
                                        }}>Purchase</button>
                                    </div>
                                    <div className="col-md-4"></div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>

            <Fragment>
                <div className={"modal " + (showInsufficientBalancePopup ? 'show' : '')} tabIndex="-1" role="dialog" style={{ display: showInsufficientBalancePopup ? 'block' : 'none', paddingRight: '17px', background: '#0000008c' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">Add Funds to create NFT</h3>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setInsufficientBalancePopup(false); setIsChecked(false) }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row" style={{ padding: '4px 7px 4px 11px' }}>
                                    {/* <p>You need <span id="floorPriceDisplay"></span> + {transactionFees}</p> */}

                                    <p className='mb-4'>Transfer funds to your wallet or add funds with PayBito. It can take up to a minute for your balance to update.</p>
                                    <div className="row">
                                        <div className="col-md-12 text-dark"><b>Balance:</b> {userBalance} ETH</div>
                                    </div>
                                    {/* <div className="row">
                                        <div className="col-md-12">
                                        </div>
                                    </div> */}
                                </div>

                                <center>
                                    <a href="https://trade.paybito.com/basic" target="_blank" className="btn btn-primary mt-4 col-md-12">Add Funds</a>
                                </center>


                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
            <Fragment>
                <div className={"modal " + (showTransferForMetaMaskPopup ? 'show' : '')} tabIndex="-1" role="dialog" style={{ display: showTransferForMetaMaskPopup ? 'block' : 'none', paddingRight: '17px', background: '#0000008c' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">Transfer NFT</h3>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setTransferForMetaMaskPopup(false); setTransferForMetaMaskSuccess(false); }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row" style={{ padding: '4px 7px 4px 11px' }}>

                                    <div className="col-md-12 text-center">
                                        {nft.metadata != undefined && <img src={nft.metadata.image.replace('ipfs://', 'https://ipfs.io/ipfs/')} className="img-fluid" alt="Image" style={{ height: '225px' }} />}
                                    </div>


                                </div>
                                {!isTransferForMetamaskSuccess ? <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Transfer to</label>
                                            <input type="text" className="form-control" id="addressToTransferForMetaMask" />
                                        </div>
                                    </div>
                                </div> : <div className="row">
                                    <div className="col-md-12 text-center">
                                        <h3 style={{ color: 'green' }}>Your Transfer is completed! </h3>
                                        {/* <p>Transfer Id : {metaMaskTransferId}</p> */}
                                    </div>
                                </div>}

                                {!isTransferForMetamaskSuccess && <center>
                                    <button type="button" className="btn btn-primary mt-4 col-md-12" onClick={() => { handleTransferThroughMetamask() }}>Transfer</button>
                                </center>}


                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
            <Fragment>
                <div className={"modal " + (showUpdateCommissionRatePopup ? 'show' : '')} tabIndex="-1" role="dialog" style={{ display: showUpdateCommissionRatePopup ? 'block' : 'none', paddingRight: '17px', background: '#0000008c' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">Update Commission Rate </h3>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setUpdateCommissionRatePopup(false); }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">

                                <div className='form-group'>
                                    <label>Commission Rate</label>
                                    <input type="text" className="form-control" placeholder="Enter New Commisssion Rate (%)" id="commissionRateField" onKeyUp={(e) => {
                                        let value = e.target.value;
                                        if (value != '') {
                                            let regex = /^(100|[1-9][0-9]?)$/gm
                                            if (value.match(regex)) {
                                                setCommissionRate(value);
                                            } else {
                                                e.target.value = value.slice(0, -1)
                                            }
                                        } else {
                                            setCommissionRate(0)
                                        }
                                    }} />
                                </div>
                                <button className="btn hvr-hover mr-2 " disabled={commissionRate < 1 || commissionRate > 100} onClick={updateCommissionRate}>Update</button>

                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>


            <Fragment>
                <div className={"modal " + (showListForSaleForMetaMaskPopup ? 'show' : '')} tabIndex="-1" role="dialog" style={{ display: showListForSaleForMetaMaskPopup ? 'block' : 'none', paddingRight: '17px', background: '#0000008c' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">List For Sale</h3>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setListForSaleForMetaMaskPopup(false); }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row" style={{ padding: '4px 7px 4px 11px' }}>

                                    <div className="col-md-12 text-center">
                                        {nft.metadata != undefined && <img src={nft.metadata.image.replace('ipfs://', 'https://ipfs.io/ipfs/')} className="img-fluid" alt="Image" />}
                                    </div>


                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label>Transfer to</label>
                                            <input type="text" className="form-control" id="addressToListForSaleForMetaMask" />
                                        </div>
                                    </div>
                                </div>

                                <center>
                                    <button type="button" className="btn btn-primary mt-4 col-md-12" onClick={() => { handleListForSaleThroughMetamask() }}>List for sale</button>
                                </center>


                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
            <Fragment>
                <div className={"modal " + (showListForSaleSuccessMetaMask ? 'show' : '')} tabIndex="-1" role="dialog" style={{ display: showListForSaleSuccessMetaMask ? 'block' : 'none', paddingRight: '17px', background: '#0000008c' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">List For Sale</h3>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setShowListForSaleSuccessMetaMask(false); }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row" style={{ padding: '4px 7px 4px 11px' }}>

                                    <div className="col-md-12 text-center">
                                        {nft.metadata != undefined && <img src={nft.metadata.image.replace('ipfs://', 'https://ipfs.io/ipfs/')} className="img-fluid" alt="Image" />}
                                    </div>
                                    <h4 className="col-md-12 text-center mt-4">Your NFT has been listed successfully with price <span id="listingPrice"></span> ETH </h4>

                                </div>


                                <center>
                                    <button type="button" className="btn btn-primary mt-4 col-md-12" onClick={() => { setShowListForSaleSuccessMetaMask(false); }}>Ok</button>
                                </center>


                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>

            <Footer />
            <Loader show={showLoader} />
        </Fragment>
    );
}

export default AssetDetails;